/**
 * How a player prefers to construct their deck. Draft is the default; classic
 * point-budget deck-building is the secondary option. Persisted locally and
 * shared across the setup screens (mirrors src/app/onboarding.ts).
 */
import { createSignal } from "solid-js";

export type BuildMode = "draft" | "classic";

const KEY = "cd-build-mode";

function read(): BuildMode {
  try {
    return localStorage.getItem(KEY) === "classic" ? "classic" : "draft";
  } catch {
    return "draft";
  }
}

const [buildMode, setBuildModeSignal] = createSignal<BuildMode>(read());
export { buildMode };

export function setBuildMode(mode: BuildMode): void {
  try {
    localStorage.setItem(KEY, mode);
  } catch {
    /* ignore */
  }
  setBuildModeSignal(mode);
}
